import { Analytics } from 'lib/events'

import { Platforms } from 'constants/events/mixpanel'

import {
  REACT_APP_MIXPANEL_SUPPLIER,
  REACT_APP_MIXPANEL_MERCHANT,
} from 'constants/envs'

export const analyticsMerchant = new Analytics(
  REACT_APP_MIXPANEL_MERCHANT,
  Platforms.MerchantPayment
)

export const analyticsSupplier = new Analytics(
  REACT_APP_MIXPANEL_SUPPLIER,
  Platforms.SalespersonApp
)
